import React, { useState } from "react";
import moment from "jalali-moment";

import { toast } from "react-toastify";
import { DatePicker } from "zaman";
import { useEffect } from "react";
import MangeDashboard from "./ManageDashboard";
import { getUserInfo, updateUserInfo } from "../../services/profile";

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export default function EditInfo() {
  const [error, seterror] = useState({ first: "", futher: "" });
  const [checked, setChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [birthday, setBirthday] = useState();
  const [isNext, setIsNext] = useState(false);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [melicode, setMelicode] = useState("");
  const [errorin, seterrorin] = useState({
    codeMeli: "",
    mobile: "",
    email: "",
  });
  function getFirstInfo() {
    getUserInfo()
      .then((res) => {
        const data = res.data?.data;
        if (res.status == 200) {
          if (data) {
            setFname(data.first_name);
            setLname(data.last_name);
            setPhone(data.mobile_number);
            setEmail(data.email);
            setMelicode(data.national_code);
            setBirthday(data.birth_date);
          } else {
          }
        }
      })
      .catch((error) => {});
  }
  useEffect(() => {
    getFirstInfo();
  }, []);
  function handelSubmitFirst(event) {
    event.preventDefault();

    setIsNext(true);
    updateUserInfo(fname, lname, null, email, melicode, birthday)
      .then((res) => {
        setIsNext(false);
        if (res.data) {
          toast.success("اطلاعات شما با موفقیت ثبت شد");
        } else {
          setIsNext(false);
        }
      })
      .catch((error) => {
        setIsNext(false);
      });
  }

  function clearBirth() {
    setBirthday("");
  }
  function handleBirth(value) {
    value = formatDate(value.value);
    value = moment(value, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
    value = value.replace("/", "-");
    value = value.replace("/", "-");
    setBirthday(value);
  }

  function checkCodeMeli(code) {
    var L = code.length;

    if (L < 8 || parseInt(code, 10) == 0) return false;
    code = ("0000" + code).substr(L + 4 - 10);
    if (parseInt(code.substr(3, 6), 10) == 0) return false;
    var c = parseInt(code.substr(9, 1), 10);
    var s = 0;
    for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
    s = s % 11;
    return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
    return true;
  }

  function handelCheck(event) {
    event.preventDefault();
    var tagName = event.target.name;
    let p = event.target.value;
    if (tagName == "mobile") {
      var pattern = new RegExp(/^09[0-9]{9}/);

      if (!pattern.test(p)) {
        seterrorin({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
      } else if (p.length == 11) {
        seterrorin({ ...error, mobile: "" });
        setPhone(p);
      } else {
        seterrorin({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
      }
    } else if (tagName == "email") {
      setEmail(p);
      var pattern = /\S+@\S+\.\S+/;

      if (pattern.test(p)) {
        seterrorin({ ...error, email: "" });
      } else {
        seterrorin({ ...error, email: "لطفا ایمیل خود را درست وارد نمایید" });
      }
    } else if (tagName == "codemeli") {
      // console.log("meli code validations.....");

      setMelicode(p);

      let res = checkCodeMeli(p);

      if (res) {
        seterrorin({ ...errorin, codeMeli: "" });
      } else {
        seterrorin({
          ...errorin,
          codeMeli: "لطفا کد ملی خود را به درستی وارد نمایید",
        });
      }
    }
  }
  return (
    <MangeDashboard>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-8">
            <form className="text-center">
              <div className="subsdFSFSNFS">
                <div className="title-form-bold">فقط یک قدم مانده</div>
                <div className="fill-info-text">
                  لطفا اطلاعات زیر را وارد کنید
                </div>
                <div className="col-12">
                  <div className="form-group mt-3 text-end mytitle-323">
                    <div className="row">
                      <div className="col-6">
                        <span className="d-flex pe-2 pb-1">نام *</span>
                        <input
                          name="name"
                          id={"firstname"}
                          className="max-100 form-input-custom"
                          value={fname}
                          onChange={(e) => setFname(e.target.value)}
                        />
                      </div>

                      <div className="col-6 ">
                        <span className="d-flex pe-2 pb-1">نام خانوادگی *</span>
                        <input
                          name="name"
                          id={"lastname"}
                          className="w-100 max-100 form-input-custom"
                          value={lname}
                          onChange={(e) => setLname(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="w-100 pt-2 pb-2">
                      <span className="d-flex pe-2 pb-1">موبایل *</span>
                      {phone ? (
                        <input
                          name="mobile"
                          id={"mobile"}
                          className="w-100 text-muted form-input-custom"
                          value={phone}
                          readOnly={true}
                        />
                      ) : (
                        <>
                          <input
                            name="mobile"
                            id={"mobile"}
                            className="w-100 form-input-custom"
                            onChange={handelCheck}
                          />

                          {errorin.mobile ? (
                            <span className="text-small text-danger padding-5612">
                              {errorin.mobile}
                            </span>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </div>
                    <div className="w-100 pt-2 pb-2">
                      <span className="d-flex pe-2 pb-1">تاریخ تولد </span>

                      <div className="g-flex-row">
                        <div className="d-child">
                          {birthday ? (
                            <>
                              <input
                                name="birth"
                                id={"birth"}
                                className="w-100 form-input-custom"
                                value={birthday}
                              />

                              <div className="clear353" onClick={clearBirth}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20.119"
                                  height="20.429"
                                  viewBox="0 0 390.119 482.429"
                                >
                                  <g
                                    id="delete-button-svgrepo-com"
                                    transform="translate(-46.155)"
                                  >
                                    <g id="Group_400" data-name="Group 400">
                                      <path
                                        id="Path_585"
                                        data-name="Path 585"
                                        d="M381.163,57.8H306.069a65.283,65.283,0,0,0-129.7,0h-75.1a55.177,55.177,0,0,0-55.111,55.117v2.828a55.168,55.168,0,0,0,34.83,51.2V427.312A55.179,55.179,0,0,0,136.1,482.429H346.333a55.178,55.178,0,0,0,55.111-55.117V166.944a55.172,55.172,0,0,0,34.83-51.2v-2.828A55.179,55.179,0,0,0,381.163,57.8ZM241.214,26.139A39.232,39.232,0,0,1,279.657,57.8H202.778A39.228,39.228,0,0,1,241.214,26.139ZM375.3,427.312a29.011,29.011,0,0,1-28.973,28.979H136.1a29.012,29.012,0,0,1-28.973-28.979V170.861H375.3Zm34.83-311.568a29.011,29.011,0,0,1-28.973,28.979h-279.9a29.011,29.011,0,0,1-28.973-28.979v-2.828a29.011,29.011,0,0,1,28.973-28.979h279.9a29.011,29.011,0,0,1,28.973,28.979v2.828Z"
                                        fill="#707070"
                                      />
                                      <path
                                        id="Path_586"
                                        data-name="Path 586"
                                        d="M171.144,422.863A13.07,13.07,0,0,0,184.213,409.8V262.641a13.069,13.069,0,1,0-26.138,0V409.795A13.068,13.068,0,0,0,171.144,422.863Z"
                                        fill="#707070"
                                      />
                                      <path
                                        id="Path_587"
                                        data-name="Path 587"
                                        d="M241.214,422.863a13.071,13.071,0,0,0,13.07-13.068V262.641a13.07,13.07,0,1,0-26.139,0V409.795A13.069,13.069,0,0,0,241.214,422.863Z"
                                        fill="#707070"
                                      />
                                      <path
                                        id="Path_588"
                                        data-name="Path 588"
                                        d="M311.284,422.863A13.07,13.07,0,0,0,324.352,409.8V262.641a13.069,13.069,0,1,0-26.138,0V409.795A13.069,13.069,0,0,0,311.284,422.863Z"
                                        fill="#707070"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              </div>
                            </>
                          ) : (
                            <DatePicker onChange={handleBirth} />
                          )}
                        </div>
                      </div>

                      {errorin.sheba ? (
                        <span className="text-small text-danger padding-5612">
                          {errorin.sheba}
                        </span>
                      ) : (
                        <span className="text-small text-muted padding-5612">
                          تاریخ تولد خود را وارد نمایید
                        </span>
                      )}
                    </div>
                    <div className="w-100 pt-2 pb-2">
                      <span className="d-flex pe-2 pb-1 code-meli-checkbox">
                        <span>کد ملی / شناسه ملی فراگیر *</span>
                        <span className="smaller-font-name">
                          <input
                            type="checkbox"
                            name="noncivilians"
                            className="noncivilian-checkbox"
                            value={checked}
                            onChange={(e) =>
                              setChecked(e.target.checked ? true : false)
                            }
                          />
                          اتباع خارجی هستم
                        </span>
                      </span>
                      <input
                        name="codemeli"
                        id={"codemeli"}
                        value={melicode}
                        className={"form-input-custom"}
                        onChange={handelCheck}
                      />
                      {errorin.codeMeli ? (
                        <span className="text-small text-danger padding-5612">
                          {errorin.codeMeli}
                        </span>
                      ) : (
                        <span className="text-small text-muted padding-5612">
                          کد ملی باید مطابق با نام و نام خانوادگی باشد
                        </span>
                      )}
                    </div>
                    <div className="w-100 pt-2 pb-2">
                      <span className="d-flex pe-2 pb-1">ایمیل </span>
                      {email ? (
                        <>
                          <input
                            name="email"
                            id={"email"}
                            className="w-100 text-muted form-input-custom"
                            value={email}
                            onChange={handelCheck}
                          />
                          {errorin.email ? (
                            <span className="text-small text-danger padding-5612">
                              {errorin.email}
                            </span>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          <input
                            name="email"
                            id={"email2"}
                            className="w-100 form-input-custom"
                            value={email}
                            onChange={handelCheck}
                          />

                          {errorin.email ? (
                            <span className="text-small text-danger padding-5612">
                              {errorin.email}
                            </span>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </div>
                    <div className="row mt-4 mb-1 text-center">
                      <div className="col-12">
                        <button
                          className="btn form-input-button-custom margin-bottom-mobile text-white btn-6464"
                          onClick={handelSubmitFirst}
                        >
                          {isNext ? (
                            <img
                              src={"./loading.svg"}
                              alt={""}
                              className={"w-loading"}
                            />
                          ) : (
                            <>ثبت</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </MangeDashboard>
  );
}
